import { createStore } from 'vuex'
import { registerModules, prefixServicesWith } from '@freebe/sdk/store'

const store = createStore({
  modules: {},
  strict: true,
  plugins: []
})

prefixServicesWith('freebe', {
  excludes: /^@(admin|partner)/,
})

registerModules(store)

export default store 